import { BrowserRouter, Navigate, Routes, Route, useParams } from "react-router-dom";
import usePushNotifications from "./hooks/usePushNotifications";

import RootLayout from "./pages/Root";
import ErrorPage from "./pages/Error";
import HomePage from "./pages/Home";
import DashboardPage from "./pages/Dashboard";
import FilePage from "./pages/File";
import PatientPage from "./pages/Patient";
import PatientAssistantPage from "./pages/PatientAssistant";
import PatientAssistantHomePage from "./pages/PatientAssistantHome";
import SchedaPsicologoPage from "./pages/SchedaPsicologo";
import NotificheTrascrizionePage from "./pages/NotificheTrascrizione";
import Auth from "./pages/Auth";
import BillingPage from "./pages/Billing";
import ProtectedRoute from "./routes/ProtectedRoute";
import { AuthProvider } from "./store/auth-context";
import { ModalProvider } from "./store/modal-context";
import { NotificationProvider } from "./store/notification-context";
import PaymentSuccess from "./pages/PaymentSuccess";
import { UserProvider } from "./store/user-context";
import ModalHost from "./components/modals/ModalHost";
import NotificationHost from "./components/notifications/NotificationHost";
import AdminDashboardPage from "./pages/AdminDashboard";
import AdminAccessModal from "./components/auth/AdminAccessModal";

function PushNotificationsInitializer() {
    usePushNotifications();
    return <></>
}

function LegacyFileRedirect() {
    const { fileId } = useParams();
    return <Navigate to={`/files/${fileId}`} replace />;
}

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <UserProvider>
                    <NotificationProvider>
                        <ModalProvider>
                            <PushNotificationsInitializer />
                            <ModalHost />
                            <NotificationHost />
                            <AdminAccessModal />
                            <Routes>
                                <Route path="/" element={<RootLayout />}>
                                    <Route element={<ProtectedRoute />}>
                                        <Route index element={<HomePage />} />
                                        <Route path="dashboard" element={<DashboardPage />} />
                                        <Route path="assistant" element={<PatientAssistantHomePage />} />
                                        <Route path="patient/:patientId" element={<PatientPage />} />
                                        <Route path="patient/:patientId/assistant" element={<PatientAssistantPage />} />
                                        <Route path="files/:fileId" element={<FilePage />} />
                                        <Route path="file/:fileId" element={<LegacyFileRedirect />} />
                                        <Route path="scheda-psicologo" element={<SchedaPsicologoPage />} />
                                        <Route path="notifiche-trascrizione" element={<NotificheTrascrizionePage />} />
                                        <Route path="billing" element={<BillingPage />} />
                                    </Route>
                                    <Route element={<ProtectedRoute requireAdmin />}>
                                        <Route path="admin-dashboard" element={<AdminDashboardPage />} />
                                    </Route>
                                    <Route path="*" element={<ErrorPage />} />
                                </Route>
                                <Route path="auth" element={<Auth />} />
                                <Route path="billing/success" element={<PaymentSuccess />} />
                                <Route path="verify-email/:token" element={<Auth status='email_verification' />} />
                                <Route path="reset-password/:token" element={<Auth status='password_reset' />} />
                            </Routes>
                        </ModalProvider>
                    </NotificationProvider>
                </UserProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
